export const environment = {

    production: false,
    loggingOn: true,
    apiRoot: "https://api-dev.mattvigg.co.uk",
    searchRoot: "https://api-dev.mattvigg.co.uk/search",

    galleriesPath: "/galleries",

    sentryTraceSampleRate: 1,

    AuthDomain: "mattvigg.eu.auth0.com",
    AuthClientId: "l1A7GliTx6U8etYMcYFPtBNi8A5M5Qtj",
    AuthApiIdentifier: "api-dev.mattvigg.co.uk",
    readScope: "read-galleries",
    writeScope: "write-galleries",
    searchScope: "query-search"
};
